// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as PromotionsActions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

import PromotionSuccess from '../components/Promotion/PromotionSuccess';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    createPromotionSuccess: state.promotions.createPromotionSuccess,
    promotion: state.promotions.promotion,
    error: state.promotions.error,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators({...PromotionsActions}, dispatch)
)(PromotionSuccess);
